<template>
  <b-modal
    :visible="isModalActive"
    :title="$t('Seller information')"
    ok-title="Accept"
    size="lg"
    @change="(val) => $emit('update:is-modal-active', val)"
  >
    <div>
      <b-overlay
        :show="isLoading"
        rounded="sm"
      >

        <validation-observer ref="formData">
          <b-form class="p-2">
            <b-row>
              <b-col cols="12">
                <!-- Detail -->
                <b-form-group
                  :label="`${$t('Name')}`"
                  label-for="register-name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Name"
                    vid="name"
                    rules="required"
                  >
                    <b-form-input
                      id="register-name"
                      v-model="name"
                      name="register-name"
                      :state="errors.name > 0 ? false : null"
                      :placeholder="$t('Name')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <!-- Detail -->
                <b-form-group
                  :label="`${$t('Address')}`"
                  label-for="register-address"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Address"
                    vid="address"
                    rules="required"
                  >
                    <b-form-input
                      id="register-address"
                      v-model="address"
                      name="register-address"
                      :state="errors.address > 0 ? false : null"
                      :placeholder="$t('Address')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <!-- Detail -->
                <b-form-group
                  :label="`${$t('Tax ID')}`"
                  label-for="register-taxID"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="TaxID"
                    vid="taxID"
                    rules="required"
                  >
                    <b-form-input
                      id="register-taxID"
                      v-model="taxID"
                      name="register-taxID"
                      :state="errors.taxID > 0 ? false : null"
                      :placeholder="$t('Tax ID')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col

                cols="12"
              >
                <b-form-group
                  :label="`${$t('Phone Number')}`"
                  label-for="register-taxID"
                >
                  <b-form-tags
                    v-model="tel"
                    no-outer-focus
                    class="mb-2"
                  >
                    <template v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
                      <b-input-group>
                        <input
                          v-bind="inputAttrs"
                          :placeholder="$t('Phone Number')"
                          class="form-control"
                          v-on="inputHandlers"
                        >
                        <b-input-group-append>
                          <b-button
                            variant="primary"
                            @click="addTag()"
                          >
                            {{ $t('Add') }}
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>

                      <div class="d-flex flex-wrap mt-2">
                        <b-badge
                          v-for="tag in tags"
                          :key="tag"
                          variant="primary"
                          class="mr-1 mb-1"
                        >
                          {{ tag }}

                          <feather-icon
                            icon="XIcon"
                            size="12"
                            @click="removeTag(tag)"
                          />
                        </b-badge>
                      </div>
                    </template>
                  </b-form-tags>
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
              >
                <b-form-group
                  :label="`${$t('Email')}`"
                  label-for="register-taxID"
                >
                  <b-form-tags
                    v-model="email"
                    no-outer-focus
                    class="mb-2"
                  >
                    <template v-slot="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
                      <b-input-group>
                        <input
                          v-bind="inputAttrs"
                          :placeholder="$t('Email')"
                          class="form-control"
                          v-on="inputHandlers"
                        >
                        <b-input-group-append>
                          <b-button
                            variant="primary"
                            @click="addTag()"
                          >
                            {{ $t('Add') }}
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>

                      <div class="d-flex flex-wrap mt-2">
                        <b-badge
                          v-for="tag in tags"
                          :key="tag"
                          variant="primary"
                          class="mr-1 mb-1"
                        >
                          {{ tag }}

                          <feather-icon
                            icon="XIcon"
                            size="12"
                            @click="removeTag(tag)"
                          />
                        </b-badge>
                      </div>
                    </template>
                  </b-form-tags>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-overlay>
    </div>
    <template #modal-footer>
      <div class="w-100">
        <div class="float-right">

          <b-button

            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            size="sm"
            class="mr-2"
            @click="save()"
          >
            {{ $t("Success") }}
            <feather-icon
              icon="ShoppingBagIcon"
              size="12"
            />
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BModal,
  BRow,
  BCol,
  BTabs,
  BTab,
  BCardText,
  BFormCheckbox,
  BButton,
  BFormInput,
  BFormGroup,
  BOverlay,
  BForm,
  BFormTags,
  BBadge,
  BInputGroup,
  BInputGroupAppend,

} from 'bootstrap-vue'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import store from '@/store'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    vSelect,
    BModal,
    // eslint-disable-next-line vue/no-unused-components
    BRow,
    // eslint-disable-next-line vue/no-unused-components
    BCol,
    BTabs,
    BTab,
    // eslint-disable-next-line vue/no-unused-components
    BCardText,
    // eslint-disable-next-line vue/no-unused-components
    BFormCheckbox,
    // eslint-disable-next-line vue/no-unused-components
    BButton,
    BFormInput,
    // eslint-disable-next-line vue/no-unused-components
    BFormGroup,
    BOverlay,
    BForm,
    // eslint-disable-next-line vue/no-unused-components
    BFormTags,
    BBadge,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  model: {
    prop: 'isModalActive',
    event: 'update:is-modal-active',
  },
  props: {
    storeModuleName: {
      type: String,
      required: true,
    },
    isModalActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isLoading: false,
      name: '',
      address: '',
      taxID: '',
      tel: [],
      email: [],
      required,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  watch: {
    isModalActive(val) {
      if (val) {
        this.get()
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit('update:is-modal-active', false)
    },
    initValues() {
      this.name = ''
      this.address = ''
      this.taxID = ''
    },
    get() {
      this.isLoading = true
      store
        .dispatch(`${this.storeModuleName}/sellerInformation`, { })
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          const {
            name, address, taxID, tel, email,
          } = result.data.data
          this.name = name
          this.address = address
          this.taxID = taxID
          this.tel = tel
          this.email = email
          this.isLoading = false
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
          // eslint-disable-next-line no-unused-vars
        })
        .catch(error => {
          this.isLoading = false

          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    save() {
      const obj = {
        name: this.name,
        address: this.address,
        taxID: this.taxID,
        tel: this.tel,
        email: this.email,
      }
      this.isLoading = true
      store
        .dispatch(`${this.storeModuleName}/saveSellerInformation`, obj)
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          const { name, address, taxID } = result.data.data
          this.name = name
          this.address = address
          this.taxID = taxID
          this.isLoading = false
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
          // eslint-disable-next-line no-unused-vars
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Success'),
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.isLoading = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
